import { render, staticRenderFns } from "./IconTransfertFile.vue?vue&type=template&id=5c12f29b&scoped=true&"
import script from "./IconTransfertFile.vue?vue&type=script&lang=js&"
export * from "./IconTransfertFile.vue?vue&type=script&lang=js&"
import style0 from "./IconTransfertFile.vue?vue&type=style&index=0&id=5c12f29b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c12f29b",
  null
  
)

export default component.exports